<script lang="ts">
    import { findHandPosition, raisedHandsOrderStore } from "../../Stores/RaisedHandsStore";
    import RaiseHandIcon from "../Icons/RaiseHandIcon.svelte";
    import { LL } from "../../../i18n/i18n-svelte";

    interface Props {
        spaceUserId: string;
        /** The space of the tile; undefined for the local tile (see findHandPosition). */
        spaceName: string | undefined;
        /** Styled as the name pill UserName shows under the Woka when there is no live video. */
        pill?: boolean;
    }

    let { spaceUserId, spaceName, pill = false }: Props = $props();

    // 1-based order in which this participant raised their hand (undefined when the hand is not raised).
    let hand = $derived(findHandPosition($raisedHandsOrderStore, spaceName, spaceUserId));
</script>

{#if hand !== undefined}
    <div
        class="flex items-center gap-1 pointer-events-none {pill
            ? 'bg-mlight/80 rounded-full px-3 py-1.5 text-mdark'
            : 'px-1'}"
        role="img"
        aria-label={hand.queueSize > 1
            ? `${$LL.actionbar.raisedHands.handRaised()} (${hand.position}/${hand.queueSize})`
            : $LL.actionbar.raisedHands.handRaised()}
        data-testid="raised-hand-badge"
    >
        <RaiseHandIcon height="h-4" width="w-4" strokeColor="stroke-current" hover="" />
        <!-- The order only matters when several hands are raised. -->
        {#if hand.queueSize > 1}
            <span class="text-sm font-bold leading-none tabular-nums">{hand.position}</span>
        {/if}
    </div>
{/if}
